export const sensorJson = {
    DRIVER:{
        install_locations:{
            field_type:"drop_down",
            values:[
                "drive-end",
                "opp-end"
            ]
        },
        axis:{
            field_type:"drop_down",
            values:[
                "X",
                "Y",
                "Z"
            ]
        }
    },
    CONNECTOR:{
        install_locations:{
            field_type:"drop_down",
            values:[
                "input-drive",
                "output-drive"
            ]
        },
        axis:{
            field_type:"drop_down",
            values:[
                "X",
                "Y",
                "Z"
            ]
        }
    },
    DRIVEN:{
        install_locations:{
            field_type:"drop_down",
            values:[
                "opp-end",
                "drive-end",
                "driver rotor drive-end",
                "driver rotor opp-end",
                "driven rotor drive-end",
                "driven rotor opp-end",
                "left-driven rotor",
                "right-driven rotor"
            ]
        },
        axis:{
            field_type:"drop_down",
            values:[
                "X",
                "Y",
                "Z"
            ]
        }

    }
}

export const bearingTypes = ['Rolling', 'Journal/Sleeve'];
